// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2UqcK","title":"AfterBackImages_title__3BGmD","images":"AfterBackImages_images__1q57R"};